import StatementTop from "../../../components/elements/statements/statementTop";
import StatementBottom from "../../../components/elements/statements/statementBottom";
import CInput from "../../../components/elements/customInput";
import CCheckbox from "../../../components/elements/customCheckbox";
import FilePicker from "../../../components/elements/filepicker";
import DatePicker from "../../../components/elements/datepicker";
import CTextarea from "../../../components/elements/customTextarea";
import CSelect from "../../../components/elements/customSelect";
import SearchInput from "../../../components/elements/searchInput";

import { scrollToElement } from "../../../helpers/helpers";
import { mapState } from "ui.vue3.vuex";

import { StatementComponentNames } from "../../../helpers/data";

import TechnicalFailureStatementStepOne from "./step-1";
import TechnicalFailureStatementStepThree from "./step-3";

const TechnicalFailureStatementStepTwo = {
    template: /*html*/ `
  <form class="statement-form" action="#">
    <StatementTop
      active-step="2"
      step-amount="3"
    />

    <div class="statement-middle">
      <div class="statement__step statement__step-2">
        <div class="area">
          <div class="area-form">
            <p class="h5">Информация о платеже</p>
            <div class="area-form__fields grid col-xxl-2 col-md-1">
              <div class="area-form__fields-item">
                <DatePicker 
                  :ref="ref_names.transaction_date"
                  :name="transaction_date.name"
                  :title="transaction_date.title"
                  :type="transaction_date.type"
                  :required="transaction_date.required"
                  v-model="data.transaction_date"
                  :validation="transaction_date.validation"
                  :mask="transaction_date.mask"
                />
              </div>
              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.transaction_time"
                  :name="transaction_time.name"
                  :title="transaction_time.title"
                  :type="transaction_time.type"
                  :required="transaction_time.required"
                  :validation="transaction_time.validation"
                  v-model="data.transaction_time"
                  :mask="transaction_time.mask"
                />
              </div>
              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.terminal_addres_or_number"
                  :name="terminal_addres_or_number.name"
                  :title="terminal_addres_or_number.title"
                  :type="terminal_addres_or_number.type"
                  :required="terminal_addres_or_number.required"
                  :validation="terminal_addres_or_number.validation"
                  v-model="data.terminal_addres_or_number"
                />
              </div>
              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.deposit_summ"
                  :name="deposit_summ.name"
                  :title="deposit_summ.title"
                  :type="deposit_summ.type"
                  :required="deposit_summ.required"
                  :validation="deposit_summ.validation"
                  v-model="data.deposit_summ"
                />
              </div>
              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.deposit_summ_deficit"
                  :name="deposit_summ_deficit.name"
                  :title="deposit_summ_deficit.title"
                  :type="deposit_summ_deficit.type"
                  :required="deposit_summ_deficit.required"
                  :validation="deposit_summ_deficit.validation"
                  v-model="data.deposit_summ_deficit"
                />
              </div>
              <div class="area-form__fields-item">
                <SearchInput
                  :ref="ref_names.transaction_provider"
                  :name="transaction_provider.name"
                  :placeholder="transaction_provider.placeholder"
                  :type="transaction_provider.type"
                  :options-list="transaction_provider_options"
                  :initial-value="{
                    text: data.transaction_provider_option.text,
                    id: data.transaction_provider_option.id,
                    icon: data.transaction_provider_option.icon,
                    selected: data.transaction_provider_option.selected,
                  }"
                  @selected_option="selectTransactionProvider"
                  @clear_option="clearTransactionProvider"
                  search-input-id="transaction_provider"
                  :required="transaction_provider.required"
                />
              </div>
              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.transaction_id"
                  :name="transaction_id.name"
                  :title="transaction_id.title"
                  :type="transaction_id.type"
                  :required="transaction_id.required"
                  :validation="transaction_id.validation"
                  v-model="data.transaction_id"
                />
              </div>
              <div class="area-form__fields-item">
                <CSelect
                  :ref="ref_names.deposit_method"
                  :name="deposit_method.name"
                  :title="deposit_method.title"
                  :required="deposit_method.required"
                  :validation="deposit_method.validation"
                  :options="deposit_method_options"
                  @selected_option="selectDepositMethod"
                  :initial-value="data.deposit_method_option"
                  select-id="deposit_method_options"
                />
              </div>
              <div class="area-form__fields-item">
                <CTextarea
                  :ref="ref_names.notes_value_and_amount"
                  :name="notes_value_and_amount.name"
                  :title="notes_value_and_amount.title"
                  :required="notes_value_and_amount.required"
                  :validation="notes_value_and_amount.validation"
                  v-model="data.notes_value_and_amount"
                />
              </div>
              <div class="area-form__fields-item">
                <CTextarea
                  :ref="ref_names.terminal_response"
                  :name="terminal_response.name"
                  :title="terminal_response.title"
                  :required="terminal_response.required"
                  :validation="terminal_response.validation"
                  v-model="data.terminal_response"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <CCheckbox
            :title="notes_in_packs.title"
            :checkbox-id="notes_in_packs.id"
            :check-var="data.notes_in_packs"
            @on_change="onNotesInPacksChange"
          />
        </div>
        <div class="area">
          <div class="area-form">
            <div class="area-form__fields grid col-xxl-1">
              <div class="area-form__fields-item">
                <CCheckbox
                  :title="terminal_deposit_assurance.title"
                  :checkbox-id="terminal_deposit_assurance.id"
                  :check-var="data.terminal_deposit_assurance"
                  @on_change="onTerminalDepositAssuranceChange"
                />
              </div>
              <div class="area-form__fields-item grid col-xxl-2 col-md-1" v-if="!data.terminal_deposit_assurance">
                <CInput
                  :ref="ref_names.terminal_deposit_place"
                  :name="terminal_deposit_place.name"
                  :title="terminal_deposit_place.title"
                  :type="terminal_deposit_place.type"
                  :required="terminal_deposit_place.required"
                  :validation="terminal_deposit_place.validation"
                  v-model="data.terminal_deposit_place"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-form">
            <p class="h5">Дополнительная информация<span></span></p>
            <div class="area-form__fields grid col-xxl-2 col-md-1">
              <div class="area-form__fields-item">
                <CTextarea
                  :ref="ref_names.additional_info"
                  :name="additional_info.name"
                  :title="additional_info.title"
                  :required="additional_info.required"
                  :validation="additional_info.validation"
                  v-model="data.additional_info"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <CCheckbox
            :title="transaction_document_copy.title"
            :checkbox-id="transaction_document_copy.id"
            :check-var="data.transaction_document_copy_attached"
            @on_change="onTransactionDocumentCopyAttached"
          />
        </div>
        <div class="area" v-if="data.transaction_document_copy_attached">
          <div class="area-form">
            <p class="h5">Извещение об оплате или другой документ подтверждающий оплату<span>*</span></p>
            <div class="area-form__fields grid col-xxl-2 col-md-1">
              <div class="area-form__fields-item">
                <FilePicker 
                  :ref="ref_names.transaction_document_file"
                  :show-notification="transaction_document_file.show_notification"
                  :notification="transaction_document_file.notification"
                  :initial-value="[...data.transaction_document_files]"
                  :required="transaction_document_file.required"
                  :multiple="transaction_document_file.multiple"
                  @files_picked="onTransactionDocumentFilesPicked"
                  @clear_files="onTransactionDocumentFilesCleared"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="area" v-else>
          <div class="area-form">
            <div class="area-form__fields grid col-xxl-2 col-md-1">
              <div class="area-form__fields-item">
                <CTextarea
                  :ref="ref_names.no_transaction_document_reason"
                  :name="no_transaction_document_reason.name"
                  :title="no_transaction_document_reason.title"
                  :required="no_transaction_document_reason.required"
                  :validation="no_transaction_document_reason.validation"
                  v-model="data.no_transaction_document_reason"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <StatementBottom 
      :next-btn="next_btn"
      :back-btn="back_btn"
      @back_clicked="onBackClicked"
      @next_clicked="onNextClicked"
    />
  </form>
  `,

    name: StatementComponentNames.technical_failure.technical_failure_two,

    props: {
        statementAnchor: {
            type: String,
            default: "",
        },

        goToComponent: {
            type: Function,
        },
    },

    computed: {
        ...mapState({
            statement_data: (state) => state.technicalFailure.data,
        }),
    },

    data() {
        return {
            next_btn: {
                show: true,
                text: "Продолжить",
                class: "",
            },

            back_btn: {
                show: true,
                text: "Назад",
                class: "",
            },

            transaction_date: {
                name: "transaction_date",
                title: "Дата",
                required: true,
                type: "text",
                validation: [["required"], ["date"], ["before", new Date()], ["after", new Date(1900, 0, 1)]],
                mask: {
                    mask: "99.99.9999",
                    showMaskOnHover: !1,
                },
            },

            transaction_time: {
                name: "transaction_time",
                title: "Время",
                required: false,
                type: "text",
                validation: [["optional"], ["time"]],
                mask: {
                    mask: "99:99:99",
                    showMaskOnHover: !1,
                },
            },

            terminal_addres_or_number: {
                name: "terminal_addres_or_number",
                title: "Номер или адрес платежного терминала",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-ЯA-Z\s\d\W]+$/i]],
            },

            deposit_summ: {
                name: "deposit_summ",
                title: "Общая сумма, которая была введена в терминал, руб.",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /(?:^[1-9]([0-9]+)?(?:\,[0-9]{1,2})?$)|(?:^(?:0)$)|(?:^[0-9]\,[0-9](?:[0-9])?$)/]],
            },

            deposit_summ_deficit: {
                name: "deposit_summ_deficit",
                title: "Сумма, которая не была перечислена и не была возвращена, руб.",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /(?:^[1-9]([0-9]+)?(?:\,[0-9]{1,2})?$)|(?:^(?:0)$)|(?:^[0-9]\,[0-9](?:[0-9])?$)/]],
            },

            transaction_provider: {
                name: "transaction_provider",
                placeholder: "Поиск по Услугам/Операторам",
                type: "text",
                required: false,
            },

            transaction_provider_options: [],

            transaction_id: {
                name: "transaction_id",
                title: "Идентификатор (счет, договор и т.д.)",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-ЯA-Z\d\s\W]+$/i], ["max", 300]],
                mask: {
                    mask: "999999999999999",
                    showMaskOnHover: !1,
                },
            },

            deposit_method: {
                name: "deposit_method",
                title: "Способ ввода данных",
                required: true,
                validation: [["required"]],
            },

            deposit_method_options: [
                {
                    text: "Данные вводили вручную",
                    id: "manual",
                    selected: false,
                },

                {
                    text: "Приложили карту",
                    id: "nfc",
                    selected: false,
                },
            ],

            notes_value_and_amount: {
                name: "notes_value_and_amount",
                title: "Количество купюр, номинал, порядок ввода",
                required: true,
                validation: [["required"], ["matches", /^[А-ЯA-Z\s\d\W]+$/i], ["max", 300]],
            },

            terminal_response: {
                name: "terminal_response",
                title: "Реакция терминала (возвращал купюры, завис, выключился и пр.)",
                required: true,
                validation: [["required"], ["matches", /^[А-ЯA-Z\s\d\W]+$/i], ["max", 300]],
            },

            notes_in_packs: {
                name: "notes_in_packs",
                title: "Купюры введены в терминал “пачкой”, все вместе",
                id: "notes_in_packs",
            },

            terminal_deposit_assurance: {
                name: "terminal_deposit_assurance",
                title: "Я уверен, что деньги были введены именно в купюроприемник",
                id: "terminal_deposit_assurance",
            },

            terminal_deposit_place: {
                name: "terminal_deposit_place",
                title: "Уточните, куда вы ввели купюры?",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-ЯA-Z\s\d\W]+$/i]],
            },

            additional_info: {
                name: "additional_info",
                title: "Информация, которую Вы считаете нужным указать",
                required: false,
                validation: [["optional"], ["max", 300]],
            },

            transaction_document_copy: {
                name: "transaction_document_copy",
                title: "К заявлению прилагаю копию Извещения об оплате или другой документ подтверждающий оплату",
                id: "transaction_document_copy",
            },

            transaction_document_file: {
                notification: "Загрузите файл в формате .jpg, .pdf",
                show_notification: true,
                required: true,
                multiple: true,
            },

            no_transaction_document_reason: {
                name: "no_transaction_document_reason",
                title: "Причина отсутствия копии Извещения об оплате или другого документа, подтверждающего оплату",
                required: true,
                validation: [["required"], ["max", 300]],
            },

            data: {
                transaction_date: "",
                transaction_time: "",
                terminal_addres_or_number: "",
                deposit_summ: "",
                deposit_summ_deficit: "",

                transaction_provider_option: {
                    text: null,
                    id: null,
                    icon: null,
                    selected: false,
                },

                transaction_id: "",
                deposit_method_option: {
                    text: null,
                    id: null,
                    selected: false,
                },
                notes_value_and_amount: "",
                terminal_response: "",
                notes_in_packs: false,

                terminal_deposit_assurance: true,
                terminal_deposit_place: "",

                additional_info: "",
                transaction_document_copy_attached: true,

                transaction_document_files: [],

                no_transaction_document_reason: "",
            },

            ref_names: {
                transaction_date: "transaction_date",
                transaction_time: "transaction_time",
                terminal_addres_or_number: "terminal_addres_or_number",
                deposit_summ: "deposit_summ",
                deposit_summ_deficit: "deposit_summ_deficit",
                transaction_provider: "transaction_provider",
                transaction_id: "transaction_id",
                deposit_method: "deposit_method",
                notes_value_and_amount: "notes_value_and_amount",
                terminal_response: "terminal_response",
                terminal_deposit_place: "terminal_deposit_place",
                additional_info: "additional_info",
                transaction_document_file: "transaction_document_file",
                no_transaction_document_reason: "no_transaction_document_reason",
            },

            ref_order: [],

            refs_with_errors: [],

            form_has_errors: false,
        };
    },

    created() {
        this.transaction_provider_options = this.$bitrix.Application.instance.php_vars.provider_options;

        this.getStoreData();

        this.setDefalutValues();

        this.fillRefOrder();
        this.onNotesInPacksChange(this.data.notes_in_packs);
        this.onTerminalDepositAssuranceChange(this.data.terminal_deposit_assurance);
        this.onTransactionDocumentCopyAttached(this.data.transaction_document_copy_attached);
    },

    methods: {
        onBackClicked() {
            this.setStatementData();
            this.scrollToTop();
            this.goToComponent({ component: TechnicalFailureStatementStepOne });
        },

        async onNextClicked() {
            this.setStatementData();

            await this.submitForm();

            if (!this.form_has_errors) {
                this.scrollToTop();
                this.goToComponent({ component: TechnicalFailureStatementStepThree });
            }
        },

        clearTransactionProviderOptions() {
            this.transaction_provider_options.forEach((option) => {
                if (option.selected) {
                    option.selected = false;
                }
            });
        },

        selectTransactionProvider(option) {
            this.clearTransactionProviderOptions();

            this.data.transaction_provider_option.text = option.text;
            this.data.transaction_provider_option.id = option.id;
            this.data.transaction_provider_option.selected = option.selected;
            this.data.transaction_provider_option.icon = option.icon;

            this.transaction_provider_options.forEach((item) => {
                if (option.id === item.id) {
                    item.selected = true;
                }
            });
        },

        clearTransactionProvider() {
            this.data.transaction_provider_option.icon = null;
            this.data.transaction_provider_option.id = null;
            this.data.transaction_provider_option.selected = false;

            this.clearTransactionProviderOptions();
        },

        setDefalutValues() {
            if (this.data.transaction_provider_option.id) {
                this.selectTransactionProvider(this.data.transaction_provider_option);
            }

            if (this.data.deposit_method_option.id) {
                this.selectDepositMethod(this.data.deposit_method_option);
            }
        },

        fillRefOrder() {
            this.ref_order = [
                this.ref_names.transaction_date,
                this.ref_names.transaction_time,
                this.ref_names.terminal_addres_or_number,
                this.ref_names.deposit_summ,
                this.ref_names.deposit_summ_deficit,
                this.ref_names.transaction_provider,
                this.ref_names.transaction_id,
                this.ref_names.deposit_method,
                this.ref_names.notes_value_and_amount,
                this.ref_names.terminal_response,
                this.ref_names.additional_info,
            ];

            if (!this.data.terminal_deposit_assurance) {
                const index = this.ref_order.findIndex((item) => item === this.ref_names.additional_info);
                this.ref_order.splice(index, 0, this.ref_names.terminal_deposit_place);
            }

            if (this.data.transaction_document_copy_attached) {
                const index = this.ref_order.findIndex((item) => item === this.ref_names.additional_info);
                this.ref_order.splice(index + 1, 0, this.ref_names.transaction_document_file);
            }

            if (!this.data.transaction_document_copy_attached) {
                const index = this.ref_order.findIndex((item) => item === this.ref_names.additional_info);
                this.ref_order.splice(index + 1, 0, this.ref_names.no_transaction_document_reason);
            }
        },

        validateForm() {
            this.refs_with_errors = [];

            this.ref_order.forEach((ref) => {
                const hasError = this.$refs[ref].hasValidationErrors();

                if (hasError) {
                    this.refs_with_errors.push(ref);
                }
            });
        },

        async submitForm() {
            this.form_has_errors = false;
            await this.$nextTick(() => {});

            this.validateForm();

            if (this.refs_with_errors.length) {
                this.form_has_errors = true;
                scrollToElement({
                    el: this.$refs[this.refs_with_errors[0]].$el,
                    time: 200,
                    animation: "swing",
                    offset: 100,
                });
            }
        },

        getStoreData() {
            this.data.transaction_date = this.statement_data.transaction_date;
            this.data.transaction_time = this.statement_data.transaction_time;
            this.data.terminal_addres_or_number = this.statement_data.terminal_addres_or_number;
            this.data.deposit_summ = this.statement_data.deposit_summ;
            this.data.deposit_summ_deficit = this.statement_data.deposit_summ_deficit;

            this.data.transaction_provider_option.text = this.statement_data.transaction_provider_option.text;
            this.data.transaction_provider_option.id = this.statement_data.transaction_provider_option.id;
            this.data.transaction_provider_option.icon = this.statement_data.transaction_provider_option.icon;
            this.data.transaction_provider_option.selected = this.statement_data.transaction_provider_option.selected;

            this.data.transaction_id = this.statement_data.transaction_id;

            this.data.deposit_method_option.text = this.statement_data.deposit_method_option.text;
            this.data.deposit_method_option.id = this.statement_data.deposit_method_option.id;
            this.data.deposit_method_option.selected = this.statement_data.deposit_method_option.selected;

            this.data.notes_value_and_amount = this.statement_data.notes_value_and_amount;
            this.data.terminal_response = this.statement_data.terminal_response;
            this.data.notes_in_packs = this.statement_data.notes_in_packs;

            this.data.terminal_deposit_assurance = this.statement_data.terminal_deposit_assurance;
            this.data.terminal_deposit_place = this.statement_data.terminal_deposit_place;
            this.data.additional_info = this.statement_data.additional_info;

            this.data.transaction_document_copy_attached = this.statement_data.transaction_document_copy_attached;
            this.data.no_transaction_document_reason = this.statement_data.no_transaction_document_reason;
            this.data.transaction_document_files = this.statement_data.transaction_document_files;
        },

        selectDepositMethod(option) {
            const selected_option = this.deposit_method_options.find((item) => item.selected);

            if (selected_option) {
                selected_option.selected = false;
            }

            this.data.deposit_method_option.text = option.text;
            this.data.deposit_method_option.id = option.id;
            this.data.deposit_method_option.selected = option.selected;

            const new_selected_option = this.deposit_method_options.find((item) => item.id === option.id);
            new_selected_option.selected = true;
        },

        setStatementData() {
            this.$store.commit("technicalFailure/setSecondStepData", { data: this.data });
        },

        scrollToTop() {
            const el = document.querySelector(`#${this.statementAnchor}`);

            if (el) {
                scrollToElement({ el: el, time: 200, animation: "swing" });
            }
        },

        onTransactionDocumentFilesPicked(files) {
            this.data.transaction_document_files = files;
        },

        onTransactionDocumentFilesCleared() {
            this.data.transaction_document_files = [];
        },

        onNotesInPacksChange(val, id) {
            this.data.notes_in_packs = val;
        },

        onTerminalDepositAssuranceChange(val, id) {
            this.data.terminal_deposit_assurance = val;

            this.fillRefOrder();
        },

        onTransactionDocumentCopyAttached(val, id) {
            this.data.transaction_document_copy_attached = val;

            if (!this.data.transaction_document_copy_attached) {
                this.onTransactionDocumentFilesCleared();
            }

            if (this.data.transaction_document_copy_attached) {
                this.data.no_transaction_document_reason = "";
            }

            this.fillRefOrder();
        },
    },

    components: {
        StatementTop,
        StatementBottom,
        CInput,
        CCheckbox,
        FilePicker,
        DatePicker,
        CTextarea,
        CSelect,
        SearchInput,
        TechnicalFailureStatementStepOne,
        TechnicalFailureStatementStepThree,
    },
};

export default TechnicalFailureStatementStepTwo;
